import React from "react";
import { Card, Typography, Space, Tooltip,Skeleton } from "antd";
import "./ComparisonCard.css";
import { formatNumber } from "../../shared/utils";
import { Box } from "@mui/system";


const { Title, Text } = Typography;

const ComparisonProductSkeletonLoad = ({ product = {}, isLabel, labels,bestValue,productIndex,}) => (
  <>
  <Card
    // style={{alignItems: isLabel ? "start": "none"}}
    className={`top-pick-card comparison-product-card comparison-product-card-label-border` }
    cover={
      <div className="comparison-card-cover">
        <div
          style={{
            width: "clamp(30px, 66%, 60px)",
            height: "clamp(30px, 50%, 60px)",
            margin: "0 auto",
            borderRadius: "6px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            visibility: "hidden",
          }}
        >
          <img
            src={""}
            alt={""}
            style={{
              width: "100%",
              height: "60px",
              objectFit: "contain",
              borderRadius: "6px",
            }}
          />
        </div>
      </div>
    }
  >
    <div style={{ textAlign: "center", overflow: "hidden",width:"100%" }}>
      <Tooltip placement="top" title={
        bestValue?.title
      }>
        <Title
          level={5}
          style={{
            margin: "0 0 clamp(9px, 1%, 12px) 0",
            fontSize: "12px",
            lineHeight: "1.3",
            fontWeight: 500,
            color: "#333",
            wordBreak:"break-word",
            whiteSpace: "normal",
            overflow: "hidden",
            textOverflow: "ellipsis",

            display: "-webkit-box",
            WebkitBoxOrient: "vertical",
            WebkitLineClamp: 2,
            height:"27px",
            padding:"0px 5px",
            visibility: bestValue?.title ? "visible" : "hidden",
          }}
        >
          {bestValue?.title }
        </Title>
      </Tooltip>




        <Box
         direction="vertical"
         size={1}
         style={{ alignItems: "center", minWidth: 0,marginBottom:"6px",width:"100%" }}
        >
          <Typography

                className="top-pick-text"
                style={{
                  fontSize: "10px",
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  margin: "0px 0px clamp(8px, 1%, 12px)",
                  textOverflow: "ellipsis",
                  fontWeight: "bold",
                  color: "rgb(51, 51, 51)",
                  padding:"3px",
                  width:"100%"
                }}
              >
                Quality
              </Typography>
              <Typography

                className="top-pick-text"
                style={{
                  fontSize: "10px",
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  margin: "0px 0px clamp(5px, 1%, 12px)",
                  textOverflow: "ellipsis",
                  fontWeight: "bold",
                  padding:"3px",
                  width:"100%",
                  background:"#ededed",
                }}
              >
                Price
              </Typography>
          {[1, 2, 3].map((i) =>
            (
              <Typography
                key={i}
                className="top-pick-text"
                style={{
                  fontSize: "10px",
                  whiteSpace: "nowrap",
                  margin: "0px 0px clamp(3px, 1%, 12px)",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  fontWeight: "bold",
                  width:"100%"
                }}
              >
                <Skeleton.Input active size="small" block style={{ width: "100%" ,height:"20px",borderRadius:"0" }} />
              </Typography>
            )
          )}
          <div
            style={{
              position: "absolute",
              // top: "-30px",
              left: "50%",
              transform: "translateX(-50%)",
              background: "#ededed",
              color: "black",
              fontSize: "10px",
              fontWeight: "bold",
              padding: "4px",
              borderRadius: "0px 0px 4px 4px",
              whiteSpace: "nowrap",
              zIndex: 10,
              height:"40px",
              width: "101%",
              wordWrap: "break-word",
              alignContent: "center",
              textAlign:"left",
                  overflow: "hidden",
                  textOverflow: "ellipsis",

            }}
          >

          </div>
        </Box>

    </div>
  </Card>
  </>
);

export default ComparisonProductSkeletonLoad;